exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-menu[data-v-a78c5f98]{margin-bottom:.4rem}.page-menu .page-menu-main[data-v-a78c5f98]{padding:.06rem .12rem;border-radius:.06rem;border:1px solid #225bfc;font-family:HurmeGeometricSans2-Bold,HurmeGeometricSans2}.page-menu[data-v-a78c5f98]  .el-radio-button--medium .el-radio-button__inner{width:2.72rem;font-size:.2rem;color:#fff;padding:.1rem .24rem;border-radius:.06rem;border:none;background-color:rgba(0,0,0,0)}.page-menu[data-v-a78c5f98]  .el-radio-button__orig-radio:checked+.el-radio-button__inner{color:#fff;font-weight:500;background:#225bfc;box-shadow:none}", ""]);

// exports
